import "./Row.scss";
import "./../customComponents/Section/Section.scss"
import ColumnClone from "../Column/ColumnClone";
import SectionClone from "../customComponents/Section/SectionClone"
import LineClone from "../customComponents/Line/LineClone"
export default function RowClone({ row }) {
  if (row?.type === "section")
    return <SectionClone section={row.data[0].data[0]} />;
  if (row?.type === "line")
    return <LineClone line={row.line} />;
  return (
    <div className="row-clone">
      {row.data.map((column, columnIndex) => (
        <ColumnClone key={columnIndex} column={column} />
      ))}
    </div>
  );
}
